'use client'

import React, { useEffect, useState } from 'react'

/**
 * Fades its children in (opacity 0 → 1) once on mount. No transform / layout
 * movement, so it never shifts surrounding content. Pairs with `SlideUpOnMount`
 * for layouts where one column slides up and another simply fades in.
 */
export function FadeInOnMount({
  children,
  className,
  style,
  id,
  durationMs = 1100,
}: {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  id?: string
  durationMs?: number
}) {
  const [state, setState] = useState<'hidden' | 'animating' | 'instant'>('hidden')

  useEffect(() => {
    const raf1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setState('animating')
      })
    })
    return () => cancelAnimationFrame(raf1)
  }, [])

  return (
    <div
      id={id}
      className={className}
      style={{
        ...style,
        opacity: state === 'hidden' ? 0 : 1,
        transition: state === 'animating' ? `opacity ${durationMs}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)` : 'none',
      }}
    >
      {children}
    </div>
  )
}
